import { CommonModule } from '@angular/common'
import { Component, OnInit, inject } from '@angular/core'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatIconModule } from '@angular/material/icon'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { FooterComponent } from 'src/app/components/footer/footer.component'
import { HeaderComponent } from 'src/app/components/header/header.component'
import { ConfigurablePageComponent } from 'src/app/core/abstracts/configurable-page.component'
import { SeoService } from 'src/app/core/services/seo.service'

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['../../../assets/page.scss', './maintenance.component.scss'],
  imports: [
    CommonModule,
    MatExpansionModule,
    MatSlideToggleModule,
    MatIconModule,
    HeaderComponent,
    FooterComponent,
  ],
})
export class MaintenanceComponent extends ConfigurablePageComponent implements OnInit {
  private _seoService = inject(SeoService)

  readonly pageTitle = $localize`:@@page.maintenance.seo.title:Maintenance Page`
  readonly pageDesc = $localize`:@@page.maintenance.seo.description:Update in progress. Please check back later.`

  ngOnInit() {
    const config = this.globalDataService.config()
    this.pageConfig.set(this.globalDataService.config().page.maintenance)
    this._seoService.init(
      config.seo.data,
      {
        title: this.pageTitle,
        description: this.pageDesc,
      }
    )
  }
}
